
import { defineComponent, onMounted, ref } from 'vue';
import { getTempUrl } from "../api/production";

export default defineComponent({
    setup() {
        const isShow = ref(false);
        onMounted(()=>{
            getTempUrl().then((res:any) => {
                if(res.data.code == 0){
                    // window.open(res.data.data.url_link);
                    location.href = res.data.data.url_link

                } else {
                    isShow.value = true;
                }

            }).catch(() => isShow.value = true)
        })
        return {
            isShow
        }
    },
})
